import { render, staticRenderFns } from "./FindBestDesignsBlocks.vue?vue&type=template&id=da7a7bf8&scoped=true"
import script from "./FindBestDesignsBlocks.vue?vue&type=script&lang=js"
export * from "./FindBestDesignsBlocks.vue?vue&type=script&lang=js"
import style0 from "./FindBestDesignsBlocks.vue?vue&type=style&index=0&id=da7a7bf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da7a7bf8",
  null
  
)

export default component.exports